import React from 'react';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    '& .MuiDialog-paperWidthMd': {
      maxWidth: 500,
    },
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: 0,
  },
  dialogContent: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  dialogIcon: {
    color: theme?.palette?.warning?.main,
    fontSize: 65,
    marginRight: 'auto',
    marginLeft: 'auto',
    display: 'block',

    '&.MuiSvgIcon-root': {
      fontSize: 65,
      display: 'block',
    },
  },
  title: {
    color: '#282525',
    fontSize: '26px',
    fontWeight: 'bold',
    letterSpacing: 0,
    textAlign: 'center',
    margin: '1.5rem 1rem',
    lineHeight: 1.3,
  },
  content: {
    fontSize: '16px',
    color: '#7B7B7B',
    letterSpacing: 0,
    padding: '0 2rem',
    margin: 0,
    textAlign: 'center',
  },
  dialogActions: {
    padding: '1.5rem 0 2rem 0 ',
    justifyContent: 'center',
  },
  closeButton: {
    color: theme?.palette?.grey?.[500],
  },
}));

const DialogConfirm = ({
  title,
  isOpen,
  onClose,
  onConfirm,
  icon,
  content,
  cancelBtnProps,
  btnLabels,
  confirmBtnComponent,
  confirmBtnProps,
  size,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className={classes.dialogRoot}
      maxWidth={size}
    >
      <DialogTitle className={classes.dialogTitle}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {icon ? icon : <WarningAmberIcon className={classes.dialogIcon} />}

        <DialogContentText className={classes.title}>{title}</DialogContentText>
        <div className={classes.content}>{content}</div>
      </DialogContent>

      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button onClick={onClose} variant="outlined" {...cancelBtnProps}>
          {btnLabels.cancel}
        </Button>
        {btnLabels.confirm && !confirmBtnComponent ? (
          <Button
            onClick={onConfirm}
            color="primary"
            variant="contained"
            {...confirmBtnProps}
          >
            {btnLabels.confirm}
          </Button>
        ) : null}
        {confirmBtnComponent ? confirmBtnComponent : null}
      </DialogActions>
    </Dialog>
  );
};

DialogConfirm.defaultProps = {
  title: '',
  open: false,
  onConfirm: () => {},
  onClose: () => {},
  btnLabels: {
    cancel: 'Cancel',
    confirm: 'Save',
  },
  size: 'xs',
};

DialogConfirm.propTypes = {
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  content: PropTypes.node,
  btnLabels: PropTypes.object,
  icon: PropTypes.node,
  cancelBtnProps: PropTypes.object,
  confirmBtnProps: PropTypes.object,
  confirmBtnComponent: PropTypes.node,
  open: PropTypes.bool.isRequired,
  size: PropTypes.string,
};

export default DialogConfirm;
